const resources = {
    pageTitle: 'Sign in for a personalized experience',
    personalizedBeautyTitle: 'Tailored product recommendations',
    perksTitle: 'Beauty Insider perks & offers',
    adviceTitle: 'Des conseils qui s’améliorent au fil du temps',
    emailPlaceholder: 'Courriel',
    passwordPlaceholder: 'Mot de passe',
    forgotPassword: 'Mot de passe oublié?',
    termsPrefix: 'By clicking "Sign In", you (1) agree to the current version of Sephora’s',
    termsOfUse: 'CONDITIONS D’UTILISATION',
    termsAnd: 'et confirmez avoir lu notre',
    privacyPolicy: 'politique de confidentialité',
    signInButton: 'Ouvrir une session',
    continueAsGuest: 'Continuer sans créer de compte',
    enterPasswordErrorMessage: 'Please enter your password.',
    passwordLengthInvalid: 'Please review your password. Passwords are 6 to 12 characters long.',
    emailEmpty: 'Please enter an e-mail address in the format username@domain.com.',
    emailInvalid: 'Please enter an e-mail address in the format username@domain.com.',
    unableToLogYouIn: 'Unable to log you in. Please try again.',
    genericErrorMessage: 'Login failed. Please try again.',
    checkEmailPassword: 'There is an error with your email and/or password. Please try again or click \"Forgot Password?\".',
    verificationFailedTitle: 'Verification Failed',
    verificationFailedMessage: 'We were unable to verify your session. Please log out and log in again to continue.',
    verificationFailedButton: 'OK'
};

export default function getResource(label) {
    return resources[label];
}
